"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1699],{

/***/ 44781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ PatientBillView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90759);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74107);
/* harmony import */ var react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_vertical_timeline_component_style_min_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _inventory_billing_BillView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61192);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);








var PatientBillView = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(props, ref) {
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), billId = ref1[0], setBillId = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), customerId = ref2[0], setCustomerId = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), customerData = ref3[0], setCustomerData = ref3[1];
    var handlePostAction = function(billId) {
        axios__WEBPACK_IMPORTED_MODULE_5___default().post("/api/backend/customer/data/save/" + props.uhid + "/" + props.qrCode + "?qId=" + props.qId, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, customerData), {
            billId: billId
        })).then(function(resp) {
            console.info(JSON.parse(resp.data));
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
            }
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (props.qrCode && props.uhid) {
            if (props.qId) {
                axios__WEBPACK_IMPORTED_MODULE_5___default().get("/api/backend/customer/data/fetch/" + props.uhid + "/" + props.qId).then(function(resp) {
                    console.log(JSON.stringify(resp.data));
                    setBillId(resp.data.billId);
                    setCustomerData(resp.data);
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                    }
                });
            } else {
                axios__WEBPACK_IMPORTED_MODULE_5___default().get("/api/backend/customer/data/fetch/latest/" + props.qrCode + "/" + props.uhid).then(function(resp) {
                    console.log(JSON.stringify(resp.data));
                    setBillId(resp.data.billId);
                    setCustomerData(resp.data);
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                    }
                });
            }
            axios__WEBPACK_IMPORTED_MODULE_5___default().get("/api/backend/customers/fetch/" + props.uhid).then(function(resp1) {
                console.log(JSON.stringify(resp1.data));
                axios__WEBPACK_IMPORTED_MODULE_5___default().get("/api/backend/inventory/customer/fetch/" + props.entityQr + "?name=" + resp1.data.name + "&contact=" + resp1.data.mobile).then(function(resp) {
                    console.log(JSON.stringify(resp.data));
                    setCustomerId(resp.data.id);
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                    }
                    axios__WEBPACK_IMPORTED_MODULE_5___default().post("/api/backend/inventory/customer/create", {
                        entityQr: props.entityQr,
                        type: "INDIVIDUAL",
                        name: resp1.data.name,
                        displayName: resp1.data.name,
                        contact1: resp1.data.mobile
                    }).then(function(resp) {
                        console.log(JSON.stringify(resp.data));
                        setCustomerId(resp.data.id);
                    }).catch(function(err) {
                        console.error(err);
                        if (err.response && err.response.status && err.response.status === 403) {
                            (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                        }
                    });
                });
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,components_utils__WEBPACK_IMPORTED_MODULE_1__/* .handleLogout */ .hY)();
                }
            });
        }
    }, [
        props.qrCode,
        props.uhid
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: customerId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_inventory_billing_BillView__WEBPACK_IMPORTED_MODULE_4__/* .BillView */ .k, {
            billId: billId,
            customerId: customerId,
            entityQr: props.entityQr,
            postAction: handlePostAction,
            source: "OPD"
        })
    });
});
PatientBillView.displayName = "PatientBillView";


/***/ }),

/***/ 80445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ InsuranceRateItemsView; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bs-datatable/lib/esm/index.js + 16 modules
var esm = __webpack_require__(51729);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 5 modules
var Modal = __webpack_require__(32321);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Table.js
var Table = __webpack_require__(75147);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
var Tooltip = __webpack_require__(43489);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./components/permissions.ts
var permissions = __webpack_require__(13677);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 9 modules
var Form = __webpack_require__(3162);
;// CONCATENATED MODULE: ./components/inventory/services/InsuranceRateItemView.tsx








var InsuranceRateItemView = function(props) {
    var getItemForm = function getItemForm() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "sku",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Sponsor",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                    className: "",
                                    value: formData["sku"] == "none" ? 0 : formData["sku"],
                                    name: "sku",
                                    onChange: function(e) {
                                        return handleChange(e);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: 0,
                                            children: "Self"
                                        }, 0),
                                        props.insurances && props.insurances.map(function(insurance) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: insurance.id,
                                                children: insurance.tpa
                                            }, insurance.id);
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "sellingPrice",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Cost (inclusive of taxes)",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    onChange: handleChange,
                                    value: formData["sellingPrice"],
                                    name: "sellingPrice",
                                    type: "number",
                                    placeholder: "Enter Price in ₹"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "text-white",
                            variant: "info",
                            type: "submit",
                            onClick: handleSubmit,
                            children: "Save"
                        })
                    }),
                    successMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-success fs-5",
                        children: successMessage
                    }),
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-danger fs-5",
                        children: errorMessage
                    })
                ]
            })
        });
    };
    var ref = (0,react.useState)({}), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)(null), successMessage = ref1[0], setSuccessMessage = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var handleSubmit = function(e) {
        if (props.skuItem && props.skuItem.id) {
            axios_default().post("/api/backend/inventory/item/batch/update/" + props.skuItem.id, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                sku: formData["sku"] ? formData["sku"] : "none"
            })).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setSuccessMessage("* Data updated");
                props.postAction();
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
                setErrorMessage("* Something went wrong!");
            });
        } else {
            axios_default().post("/api/backend/inventory/item/batch/create", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                sku: formData["sku"] ? formData["sku"] : "none"
            })).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setSuccessMessage("* Data updated");
                props.postAction();
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
                setErrorMessage("* Something went wrong!");
            });
        }
    };
    var handleChange = function(e) {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    (0,react.useEffect)(function() {
        if (props.skuItem) {
            setFormData((0,_object_spread/* default */.Z)({}, formData, props.skuItem));
        }
    }, [
        props.skuItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: getItemForm()
    });
};

;// CONCATENATED MODULE: ./components/inventory/services/InsuranceRateItemsView.tsx












var InsuranceRateItemsView = function(props) {
    var fetchInsurances = function fetchInsurances() {
        axios_default().get("/api/backend/ipd/insurance/provider/fetch/all/" + props.cookieEntityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            if (resp.data) {
                setInsurances(resp.data);
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var fetchItems = function fetchItems() {
        axios_default().get("/api/backend/inventory/item/batch/fetch/all/" + props.itemId).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setItems(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getModalForItem = function getModalForItem() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showItemModal,
            onHide: handleRemoveItemModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceRateItemView, {
                        insurances: insurances,
                        skuItem: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, skuItem), {
                            itemId: props.itemId
                        }),
                        postAction: handlePostAction
                    })
                })
            ]
        });
    };
    var getItemsTable = function getItemsTable() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "overflow-scroll",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DatatableWrapper */.sm, {
                body: items,
                headers: ITEMS_HEADERS,
                paginationOptionsProps: {
                    initialState: {
                        rowsPerPage: 30,
                        options: [
                            30,
                            50,
                            100
                        ]
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableHeader */.xD, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableBody */.RM, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "mt-4 p-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            sm: 12,
                            lg: 12,
                            className: "d-flex flex-col justify-content-end align-items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Pagination */.tl, {})
                        })
                    })
                ]
            })
        });
    };
    var ref = (0,react.useState)([]), items = ref[0], setItems = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme"
    ]), 1), cookies = ref1[0];
    var ref2 = (0,react.useState)([]), insurances = ref2[0], setInsurances = ref2[1];
    (0,react.useEffect)(function() {
        fetchInsurances();
    }, [
        props.cookieEntityQr
    ]);
    (0,react.useEffect)(function() {
        fetchItems();
    }, [
        props.itemId
    ]);
    var handlePostAction = function() {
        setShowItemModal(false);
        fetchItems();
    };
    var ref3 = (0,react.useState)(), skuItem = ref3[0], setSkuItem = ref3[1];
    var ref4 = (0,react.useState)(false), showItemModal = ref4[0], setShowItemModal = ref4[1];
    var handleRemoveItemModal = function() {
        return setShowItemModal(false);
    };
    var handleShowItemModal = function(item) {
        setSkuItem(item);
        setShowItemModal(true);
    };
    (0,react.useEffect)(function() {
        fetchItems();
    }, []);
    var renderTooltip = function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: "button-tooltip"
        }, props), {
            children: "Item is running low in quantity"
        }));
    };
    var ITEMS_HEADERS = [
        {
            prop: "sku",
            title: "Sponsor",
            cell: function(row) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "#/",
                        className: "text-primary text-decoration-none",
                        onClick: function(e) {
                            return handleShowItemModal(row);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                height: "14rem",
                                width: "14rem",
                                src: "/external-link.png",
                                alt: "external-link-icon",
                                className: "align-self-center"
                            }),
                            "\xa0\xa0",
                            row.sku == "none" ? "Self" : insurances && ((ref = insurances.filter(function(insurance) {
                                return insurance.id == row.sku;
                            })[0]) === null || ref === void 0 ? void 0 : ref.tpa)
                        ]
                    })
                });
            }
        },
        {
            prop: "sellingPrice",
            title: "Cost (inclusive of Taxes)"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row my-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card p-2 shadow-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex justify-content-between py-2 pr-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "text-primary pl-1",
                                    children: "Rate Card"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: (0,permissions/* hasInternalPermissions */.MJ)(cookies.qme, permissions/* INVENTORY */.Qy) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                className: "btn btn-warning btn-sm text-white",
                                                onClick: function(e) {
                                                    return handleShowItemModal(null);
                                                },
                                                children: "+ Add Rate"
                                            }),
                                            "\xa0"
                                        ]
                                    })
                                })
                            ]
                        }),
                        getItemsTable(),
                        getModalForItem()
                    ]
                })
            })
        })
    });
};


/***/ }),

/***/ 1178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ MedicalServicesView; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bs-datatable/lib/esm/index.js + 16 modules
var esm = __webpack_require__(51729);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 5 modules
var Modal = __webpack_require__(32321);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Table.js
var Table = __webpack_require__(75147);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Form.js + 9 modules
var Form = __webpack_require__(3162);
// EXTERNAL MODULE: ./components/inventory/services/InsuranceRateItemsView.tsx + 1 modules
var InsuranceRateItemsView = __webpack_require__(80445);
;// CONCATENATED MODULE: ./components/inventory/services/MedicalServiceView.tsx









var MedicalServiceView = function(props) {
    var fetchItem = function fetchItem() {
        axios_default().get("/api/backend/inventory/item/fetch/" + props.cookieEntityQr + "?type=" + props.type + "&name=" + encodeURIComponent(props.name) + "&category=" + encodeURIComponent(props.category)).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setItemId(resp.data.id);
            setFormData(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getItemForm = function getItemForm() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row",
                children: [
                    !props.category && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "category",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Category",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Select */.Z.Select, {
                                    className: "form-select",
                                    value: formData["category"],
                                    name: "category",
                                    onChange: function(e) {
                                        return handleChange(e);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Medical Services",
                                            children: "Medical Services"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Medical Procedures",
                                            children: "Medical Procedures"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: "Others",
                                            children: "Others"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "name",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Name",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    value: formData["name"],
                                    onChange: handleChange,
                                    name: "name",
                                    type: "text",
                                    placeholder: "Enter name"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "intraStateTaxPerc",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: "Tax %"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    onChange: handleChange,
                                    value: formData["intraStateTaxPerc"],
                                    name: "intraStateTaxPerc",
                                    type: "tel",
                                    placeholder: "Enter Tax %"
                                })
                            ]
                        })
                    }),
                    !itemId && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col col-12 col-lg-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Group */.Z.Group, {
                            className: "mb-3",
                            controlId: "sellingPrice",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* default.Label */.Z.Label, {
                                    className: "fs-7 text-secondary",
                                    children: [
                                        "Cost (inclusive of taxes)",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-danger",
                                            children: "*"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                                    onChange: function(e) {
                                        return setSellingPrice(e.target.value);
                                    },
                                    name: "sellingPrice",
                                    type: "number",
                                    placeholder: "Enter Price in ₹"
                                })
                            ]
                        })
                    }),
                    itemId && /*#__PURE__*/ (0,jsx_runtime.jsx)(InsuranceRateItemsView/* InsuranceRateItemsView */.C, {
                        itemId: itemId,
                        cookieEntityQr: props.cookieEntityQr
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "text-white",
                            variant: "info",
                            type: "submit",
                            onClick: handleSubmit,
                            children: "Save"
                        })
                    }),
                    successMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-success fs-5",
                        children: successMessage
                    }),
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-danger fs-5",
                        children: errorMessage
                    })
                ]
            })
        });
    };
    var ref = (0,react.useState)({}), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)(null), successMessage = ref1[0], setSuccessMessage = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var ref3 = (0,react.useState)(null), itemId = ref3[0], setItemId = ref3[1];
    var ref4 = (0,react.useState)(null), sellingPrice = ref4[0], setSellingPrice = ref4[1];
    var handleSubmit = function(e) {
        if (itemId) {
            axios_default().post("/api/backend/inventory/item/update/" + itemId, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                type: "SERVICE",
                category: props.category ? props.category : formData["category"] ? formData["category"] : "Medical Services",
                entityQr: props.cookieEntityQr,
                taxable: formData["intraStateTaxPerc"] != null,
                expirable: false,
                stockQuantity: 1,
                sku: "none",
                unit: "BOX"
            })).then(function(resp) {
                console.log(JSON.stringify(resp.data));
                setSuccessMessage("* Data updated");
                props.postAction();
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
                setErrorMessage("* Something went wrong!");
            });
        } else {
            axios_default().post("/api/backend/inventory/item/create", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                type: "SERVICE",
                category: props.category ? props.category : formData["category"] ? formData["category"] : "Medical Services",
                entityQr: props.cookieEntityQr,
                taxable: formData["intraStateTaxPerc"] != null,
                expirable: false,
                stockQuantity: 1,
                sku: "none",
                unit: "BOX"
            })).then(function(resp1) {
                axios_default().post("/api/backend/inventory/item/batch/create", {
                    itemId: resp1.data.id,
                    sku: "none",
                    sellingPrice: sellingPrice
                }).then(function(resp2) {
                    console.log(JSON.stringify(resp2.data));
                    setSuccessMessage("* Data updated");
                    props.postAction();
                }).catch(function(err) {
                    console.error(err);
                    if (err.response && err.response.status && err.response.status === 403) {
                        (0,utils/* handleLogout */.hY)();
                    }
                    setErrorMessage("* Something went wrong!");
                });
            }).catch(function(err) {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 403) {
                    (0,utils/* handleLogout */.hY)();
                }
                setErrorMessage("* Something went wrong!");
            });
        }
    };
    var handleChange = function(e) {
        setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
    };
    (0,react.useEffect)(function() {
        setFormData((0,_object_spread/* default */.Z)({}, formData));
        if (props.name) {
            fetchItem();
        }
    }, [
        props.name
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: getItemForm()
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react-simple-wysiwyg/lib/index.es.mjs
var index_es = __webpack_require__(72983);
;// CONCATENATED MODULE: ./components/diagnostics/AddDiagnosticServicesTemplateView.tsx










var AddDiagnosticServicesTemplateView = function(props) {
    var ref = (0,react.useState)(null), errorMessage = ref[0], setErrorMessage = ref[1];
    var ref1 = (0,react.useState)([]), parameters = ref1[0], setParameters = ref1[1];
    var ref2 = (0,react.useState)(null), notes = ref2[0], setNotes = ref2[1];
    var ref3 = (0,react.useState)({}), addParam = ref3[0], setAddParam = ref3[1];
    var ref4 = (0,react.useState)(), testName = ref4[0], setTestName = ref4[1];
    var ref5 = (0,react.useState)(), testType = ref5[0], setTestType = ref5[1];
    var handleRemove = function(index) {
        setErrorMessage("");
        parameters.splice(index, 1);
    };
    var handleAdd = function() {
        setParameters((0,_to_consumable_array/* default */.Z)(parameters).concat([
            addParam
        ]));
        setAddParam({});
    };
    var handleSave = function() {
        setErrorMessage("");
        parameters.forEach(function(p) {
            p["entityQr"] = props.cookieEntityQr;
            p["type"] = "system";
            p["paramType"] = "VARIABLE";
        });
        axios_default().post("/api/backend/templates/create", {
            params: (0,_to_consumable_array/* default */.Z)(parameters).concat([
                {
                    entityQr: props.cookieEntityQr,
                    name: "Notes",
                    type: "system",
                    paramType: "CONSTANT",
                    description: notes
                }
            ]),
            qr: props.cookieEntityQr,
            category: props.category,
            subCategory: testType,
            name: testName
        }).then(function(resp) {
            console.log(resp.data);
            props.postAction();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setErrorMessage("* Something went wrong!");
        });
    };
    var handleChange = function(e) {
        var bioref = null;
        if (e.target.name == "rangeStart") {
            if (addParam["rangeEnd"]) {
                bioref = e.target.value + " - " + addParam["rangeEnd"];
            } else {
                bioref = ">= " + e.target.value;
            }
        }
        if (e.target.name == "rangeEnd") {
            if (addParam["rangeStart"]) {
                bioref = addParam["rangeStart"] + " - " + e.target.value;
            } else {
                bioref = "<= " + e.target.value;
            }
        }
        if (bioref) {
            var _obj;
            setAddParam((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addParam), (_obj = {}, (0,_define_property/* default */.Z)(_obj, e.target.name, e.target.value), (0,_define_property/* default */.Z)(_obj, "bioReference", bioref), _obj)));
        } else {
            setAddParam((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addParam), (0,_define_property/* default */.Z)({}, e.target.name, e.target.value)));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "min-vh-100",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                className: "text-info",
                children: "Test name:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "form-control form-control-sm",
                value: testName,
                onChange: function(e) {
                    return setTestName(e.target.value);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                className: "text-info mt-4",
                children: "Test type:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: "form-control form-control-sm",
                value: testType,
                onChange: function(e) {
                    return setTestType(e.target.value);
                },
                placeholder: "Eg. Blood Test, Urine Test etc."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Label */.Z.Label, {
                className: "text-info mt-4",
                children: "Test Parameters:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "table",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("thead", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Parameter Name"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Units"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Range Start"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Range End"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "bioReference"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: "Action"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            parameters && parameters.map(function(p) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.units
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.rangeStart
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.rangeEnd
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.bioReference
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: p.entityQr != "system" && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "#/",
                                                className: "remove text-decoration-none",
                                                onClick: function() {
                                                    return handleRemove(p.id);
                                                },
                                                children: "X"
                                            })
                                        })
                                    ]
                                }, p.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "name",
                                            value: addParam["name"] ? addParam["name"] : "",
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "units",
                                            value: addParam["units"] ? addParam["units"] : "",
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "rangeStart",
                                            value: addParam["rangeStart"] ? addParam["rangeStart"] : "",
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "rangeEnd",
                                            value: addParam["rangeEnd"] ? addParam["rangeEnd"] : "",
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: "form-control form-control-sm",
                                            name: "bioReference",
                                            value: addParam["bioReference"] ? addParam["bioReference"] : "",
                                            onChange: function(e) {
                                                return handleChange(e);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn btn-sm btn-warning text-white",
                                            onClick: function() {
                                                return handleAdd();
                                            },
                                            children: "+ Add"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Group */.Z.Group, {
                controlId: "notes",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                    containerProps: {
                        style: {
                            resize: "vertical",
                            minHeight: "200px"
                        }
                    },
                    value: notes,
                    onChange: function(e) {
                        return setNotes(e.target.value);
                    },
                    placeholder: "Write Notes to be printed on all reports"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "btn btn-warning text-white",
                onClick: function() {
                    return handleSave();
                },
                children: "Save"
            }),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-danger fs-5",
                children: errorMessage
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/diagnostics/AddDiagnosticServicesView.tsx










var AddDiagnosticServicesView = function(props) {
    var fetchItems = function fetchItems() {
        axios_default().get("/api/backend/templates/fetch/unused/" + props.category + "/" + props.cookieEntityQr).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            setAvailableOptions(resp.data);
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getItemsTable = function getItemsTable() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "overflow-scroll",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* DatatableWrapper */.sm, {
                body: selectedOptions,
                headers: ITEMS_HEADERS,
                paginationOptionsProps: {
                    initialState: {
                        rowsPerPage: 30,
                        options: [
                            30,
                            50,
                            100
                        ]
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableHeader */.xD, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableBody */.RM, {})
                    ]
                })
            })
        });
    };
    var getModalForAdd = function getModalForAdd() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showAddModal,
            onHide: handleCloseAddModal,
            backdrop: "static",
            className: "modal-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Body */.Z.Body, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddDiagnosticServicesTemplateView, {
                        cookieEntityQr: props.cookieEntityQr,
                        category: props.category,
                        postAction: handleCloseAddModal
                    })
                })
            ]
        });
    };
    var ref = (0,react.useState)(null), errorMessage = ref[0], setErrorMessage = ref[1];
    var ref1 = (0,react.useState)([]), availableOptions = ref1[0], setAvailableOptions = ref1[1];
    var ref2 = (0,react.useState)([]), selectedOptions = ref2[0], setSelectedOptions = ref2[1];
    var ref3 = (0,react.useState)(false), pricesView = ref3[0], setPricesView = ref3[1];
    var handleSave = function() {
        axios_default().post("/api/backend/templates/create/inventory/" + props.category + "/" + props.cookieEntityQr, selectedOptions).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            if (props.postAction) {
                props.postAction();
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setErrorMessage("* Something went wrong! Please try again in sometime.");
        });
    };
    var handleChange = function(checked, value) {
        if (checked) {
            setSelectedOptions(function(oldOpt) {
                return (0,_to_consumable_array/* default */.Z)(oldOpt).concat([
                    (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, value), {
                        cost: 0,
                        tax: 18
                    })
                ]);
            });
        } else {
            setSelectedOptions(function(oldOpt) {
                return oldOpt.filter(function(o) {
                    return o.id != value.id;
                });
            });
        }
    };
    var handleCostChange = function(id, value) {
        selectedOptions.filter(function(o) {
            return o.id == id;
        })[0].cost = value;
    };
    var handleTaxChange = function(id, value) {
        selectedOptions.filter(function(o) {
            return o.id == id;
        })[0].tax = value;
    };
    (0,react.useEffect)(function() {
        if (props.cookieEntityQr) {
            fetchItems();
        }
    }, [
        props.cookieEntityQr
    ]);
    var ITEMS_HEADERS = [
        {
            prop: "name",
            title: "Name"
        },
        {
            prop: "tax",
            title: "Tax %",
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                            onChange: function(e) {
                                return handleTaxChange(row.id, e.target.value);
                            },
                            name: "tax",
                            type: "text",
                            placeholder: "Tax %"
                        })
                    ]
                });
            }
        },
        {
            prop: "cost",
            title: "Cost",
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Control */.Z.Control, {
                        onChange: function(e) {
                            return handleCostChange(row.id, e.target.value);
                        },
                        name: "cost",
                        type: "text",
                        placeholder: "Enter Cost"
                    })
                });
            }
        }
    ];
    var ref4 = (0,react.useState)(false), showAddModal = ref4[0], setShowAddModal = ref4[1];
    var handleCloseAddModal = function() {
        setShowAddModal(false);
        fetchItems();
    };
    var handleShowAddModal = function() {
        setShowAddModal(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !pricesView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "d-flex justify-content-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-secondary fs-4",
                                children: "Select Services"
                            }),
                            props.category == "Lab" && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn btn-warning btn-sm text-white",
                                onClick: handleShowAddModal,
                                children: "+ Create New Test"
                            }),
                            getModalForAdd()
                        ]
                    }),
                    availableOptions.map(function(cat) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "my-3 fs-5",
                                    children: cat.subCategory
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pl-5",
                                    children: cat.items.map(function(serv) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "my-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default.Check */.Z.Check, {
                                                label: serv.name,
                                                name: cat.subCategory,
                                                type: "checkbox",
                                                checked: selectedOptions.filter(function(o) {
                                                    return o.id == serv.id;
                                                }).length > 0,
                                                onChange: function(e) {
                                                    return handleChange(e.target.checked, serv);
                                                }
                                            })
                                        }, serv.id);
                                    })
                                })
                            ]
                        });
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "btn btn-info text-white",
                            onClick: function(e) {
                                return setPricesView(true);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: "Next"
                            })
                        })
                    })
                ]
            }),
            pricesView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-secondary fs-4 mb-3",
                        children: "Add Prices"
                    }),
                    getItemsTable(),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-5 d-flex gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn btn-warning text-white",
                                onClick: function(e) {
                                    return setPricesView(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "< Back"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn btn-info text-white",
                                onClick: handleSave,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "Save"
                                })
                            })
                        ]
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-danger fs-5",
                children: errorMessage
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/inventory/services/MedicalServicesView.tsx








var MedicalServicesView = function(props) {
    var fetchItems = function fetchItems() {
        axios_default().get("/api/backend/inventory/item/fetch/all/" + props.cookieEntityQr + "?type=SERVICE").then(function(resp) {
            console.log(JSON.stringify(resp.data));
            if (props.category) {
                setItems(resp.data.filter(function(d) {
                    return d.category == props.category;
                }));
            } else {
                setItems(resp.data.filter(function(d) {
                    return d.category != "Beds";
                }));
            }
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        });
    };
    var getModalForItem = function getModalForItem() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showItemModal,
            onHide: handleRemoveItemModal,
            backdrop: "static",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Header */.Z.Header, {
                    closeButton: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                    children: [
                        (itemName || props.category != "Lab" && props.category != "Radiology") && /*#__PURE__*/ (0,jsx_runtime.jsx)(MedicalServiceView, {
                            cookieEntityQr: props.cookieEntityQr,
                            type: itemType,
                            name: itemName,
                            category: itemCategory,
                            postAction: handlePostAction
                        }),
                        !itemName && (props.category == "Lab" || props.category == "Radiology") && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddDiagnosticServicesView, {
                            cookieEntityQr: props.cookieEntityQr,
                            category: props.category,
                            postAction: handlePostAction
                        })
                    ]
                })
            ]
        });
    };
    var getModalForDeleteCase = function getModalForDeleteCase() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showDeleteModal,
            onHide: handleCloseDeleteModal,
            backdrop: "static",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-5 my-3 text-danger",
                            children: "Please note that this item will not be accessible anymore. Please consider using the same item and updating the stock. Please confirm if you still want to proceed."
                        }),
                        deleteError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-7 text-danger my-3",
                            children: deleteError
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Footer */.Z.Footer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "btn btn-secondary",
                            onClick: handleCloseDeleteModal,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "btn btn-primary text-white",
                            onClick: function(e) {
                                return handleDelete(selectedIdForDelete);
                            },
                            children: "Confirm"
                        })
                    ]
                })
            ]
        });
    };
    var getItemsTable = function getItemsTable() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "overflow-scroll",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* DatatableWrapper */.sm, {
                body: items,
                headers: ITEMS_HEADERS,
                paginationOptionsProps: {
                    initialState: {
                        rowsPerPage: 30,
                        options: [
                            30,
                            50,
                            100
                        ]
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        className: "mb-4 p-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 4,
                                className: "d-flex flex-col justify-content-end align-items-end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Filter */.wn, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                className: "d-flex flex-col justify-content-lg-center align-items-center justify-content-sm-start mb-2 mb-sm-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* PaginationOptions */.c_, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                className: "d-flex flex-col justify-content-end align-items-end",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Pagination */.tl, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        className: "btn btn-warning text-white",
                                        onClick: fetchItems,
                                        children: "↺"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableHeader */.xD, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TableBody */.RM, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        className: "mt-4 p-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: 12,
                            sm: 12,
                            lg: 12,
                            className: "d-flex flex-col justify-content-end align-items-end",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Pagination */.tl, {})
                        })
                    })
                ]
            })
        });
    };
    var ref = (0,react.useState)([]), items = ref[0], setItems = ref[1];
    var handlePostAction = function() {
        setShowItemModal(false);
        fetchItems();
    };
    var ref1 = (0,react.useState)(), itemType = ref1[0], setItemType = ref1[1];
    var ref2 = (0,react.useState)(), itemName = ref2[0], setItemName = ref2[1];
    var ref3 = (0,react.useState)(), itemCategory = ref3[0], setItemCategory = ref3[1];
    var ref4 = (0,react.useState)(false), showItemModal = ref4[0], setShowItemModal = ref4[1];
    var handleRemoveItemModal = function() {
        return setShowItemModal(false);
    };
    var handleShowItemModal = function(itemType, itemName, itemCategory) {
        setItemName(itemName);
        setItemType(itemType);
        setItemCategory(itemCategory);
        setShowItemModal(true);
    };
    var handleDelete = function(id) {
        axios_default()["delete"]("/api/backend/inventory/item/delete/id/" + id).then(function(resp) {
            console.log(JSON.stringify(resp.data));
            fetchItems();
            handleCloseDeleteModal();
        }).catch(function(err) {
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
            setDeleteError("Something went wrong! Please try again later.");
        });
    };
    var ref5 = (0,react.useState)(false), showDeleteModal = ref5[0], setShowDeleteModal = ref5[1];
    var ref6 = (0,react.useState)(), selectedIdForDelete = ref6[0], setSelectedIdForDelete = ref6[1];
    var ref7 = (0,react.useState)(null), deleteError = ref7[0], setDeleteError = ref7[1];
    var handleCloseDeleteModal = function() {
        return setShowDeleteModal(false);
    };
    var handleShowDeleteModal = function(selectedIdForDelete) {
        setDeleteError(null);
        setSelectedIdForDelete(selectedIdForDelete);
        setShowDeleteModal(true);
    };
    (0,react.useEffect)(function() {
        fetchItems();
    }, [
        props.cookieEntityQr
    ]);
    var ITEMS_HEADERS = [
        {
            prop: "category",
            title: "Category",
            isFilterable: true,
            isSortable: true
        },
        {
            prop: "name",
            title: "Name",
            isFilterable: true,
            isSortable: true
        },
        {
            prop: "intraStateTaxPerc",
            title: "Tax %"
        },
        {
            prop: "button",
            cell: function(row) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#/",
                            className: "edit",
                            onClick: function() {
                                return handleShowItemModal(row.type, row.name, row.category);
                            },
                            children: "✏️"
                        }),
                        "\xa0\xa0\xa0\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "#/",
                            className: "remove",
                            onClick: function(e) {
                                return handleShowDeleteModal(row.id);
                            },
                            children: "X"
                        })
                    ]
                });
            }
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "row my-5",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "card p-2 shadow-sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "d-flex justify-content-between py-2 pr-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "text-primary pl-1",
                                    children: "Manage Services"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "btn btn-warning btn-sm text-white",
                                    onClick: function(e) {
                                        return handleShowItemModal(null, null, props.category);
                                    },
                                    children: "+ Add New"
                                })
                            ]
                        }),
                        getItemsTable(),
                        getModalForItem(),
                        getModalForDeleteCase()
                    ]
                })
            })
        })
    });
};


/***/ })

}]);